export const SDK_VERSION = '2.2.7';
export const BEACON_VERSION = '2';
//# sourceMappingURL=constants.js.map